import { EntryrecordLoginTypeEnum } from './entryrecord-login-type-enum'

export interface EntryrecordInterface {
  /**
   * 学校 Id
   */
  schoolId: number
  operatorId: number
  /**
   * 操作者所属领域
   */
  operatorDomain: string
  /**
   * 登录方式
   */
  operatedAt?: string | null
  loginType: EntryrecordLoginTypeEnum
  /**
   * ip
   */
  ip?: string
  lastIp?: string
  os?: string
  lastOs?: string
  browser?: string
  lastBrowser?: string
  device?: string
  lastDevice?: string
  address?: string
  lastAddress?: string
  createdAt?: string
  updatedAt?: string
}

export class Entryrecord implements EntryrecordInterface {
  /**
   * 学校 Id
   */
  schoolId: number
  operatorId: number
  /**
   * 操作者所属领域
   */
  operatorDomain: string
  /**
   * 登录方式
   */
  operatedAt?: string | null
  loginType: EntryrecordLoginTypeEnum
  /**
   * ip
   */
  ip?: string
  lastIp?: string
  os?: string
  lastOs?: string
  browser?: string
  lastBrowser?: string
  device?: string
  lastDevice?: string
  address?: string
  lastAddress?: string
  createdAt?: string
  updatedAt?: string

  constructor(props: EntryrecordInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      schoolId: _schoolId,
      operatorId: _operatorId,
      operatorDomain: _operatorDomain,
      operatedAt: _operatedAt,
      loginType: _loginType,
      ip: _ip,
      lastIp: _lastIp,
      os: _os,
      lastOs: _lastOs,
      browser: _browser,
      lastBrowser: _lastBrowser,
      device: _device,
      lastDevice: _lastDevice,
      address: _address,
      lastAddress: _lastAddress,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.schoolId = _schoolId
    this.operatorId = _operatorId
    this.operatorDomain = _operatorDomain
    this.operatedAt = _operatedAt
    this.loginType = _loginType
    this.ip = _ip
    this.lastIp = _lastIp
    this.os = _os
    this.lastOs = _lastOs
    this.browser = _browser
    this.lastBrowser = _lastBrowser
    this.device = _device
    this.lastDevice = _lastDevice
    this.address = _address
    this.lastAddress = _lastAddress
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
